import { ArrowUp, Menu } from 'lucide-react'

import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { PANEL_WIDTH } from './AgentSurface'
import { AgentTab, AgentTabBar } from './AgentTabBar'
import { Message } from './contacts'
import { MessageList } from './MessageList'

/** What the agent answers to before the flow asks for a name. */
const UNNAMED = 'Cai'

interface OnboardingMockProps {
  height: number
  thread: Message[]
  /** The name it has earned by this screen; the brand's own until then. */
  agentName?: string
}

/**
 * Signing up, before there is an account to put tabs on. No people around the
 * agent either — none of that exists yet.
 */
export function OnboardingMock({ height, thread, agentName = UNNAMED }: OnboardingMockProps) {
  return (
    <div
      style={{ width: PANEL_WIDTH, height }}
      className="border-ink-100 flex flex-col overflow-hidden rounded-xl border bg-white shadow-xl"
    >
      <div className="relative flex flex-col items-center pt-3 pb-2">
        <span className="absolute top-3 left-3 flex h-11 items-center">
          <Menu className="text-ink-300 size-4 shrink-0" />
        </span>
        <Avatar className="size-11 rounded-lg border-4 border-white shadow-md">
          {/* Empty on purpose: the agent is a character, and none is drawn yet. */}
          <AvatarFallback className="bg-brand-100 rounded-lg" />
        </Avatar>
        <span className="text-ink relative z-10 -mt-1.5 rounded-full border border-white/60 bg-white/50 px-2 py-0.5 text-[10px] leading-none font-medium shadow-sm backdrop-blur-md">
          {agentName}
        </span>
      </div>
      <MessageList messages={thread} />
      <div className="p-2">
        <div className="border-ink-100 flex items-center gap-2 rounded-xl border px-3 py-2">
          <span className="text-ink-400 flex-1 truncate text-xs">Message {agentName}</span>
          <span className="bg-ink flex size-6 shrink-0 items-center justify-center rounded-full">
            <ArrowUp className="size-3.5 text-white" />
          </span>
        </div>
      </div>
      {/* Chrome, not navigation: there is nothing behind these tabs until the
          account exists, so the bar is shown rather than wired. */}
      <AgentTabBar tab={AgentTab.CHAT} connect />
    </div>
  )
}
